(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cus-contact-us"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cus-contact')) {
    customElements.define('cus-contact', class extends HTMLElement {
      connectedCallback() {
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.setupForm();
        this.setupSuccess();
      }

      setupForm() {
        const form = this.querySelector('form[data-contact-form]');
        const fields = this.querySelectorAll('[data-field]');
        if (!form || !fields.length) return;

        const check = (field) => {
          const control = field.querySelector('input, select, textarea');
          if (!control || !control.required) return true;

          const value = control.value.trim();
          let valid = value.length > 0;
          let message = control.dataset.msg || 'Please complete this field.';

          if (valid && control.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
            valid = false;
            message = control.dataset.msgInvalid || message;
          }

          if (valid && control.tagName === 'TEXTAREA' && value.length < 10) {
            valid = false;
            message = control.dataset.msgInvalid || 'Please enter at least 10 characters.';
          }

          field.classList.toggle('has-error', !valid);
          control.setAttribute('aria-invalid', String(!valid));
          const error = field.querySelector('.reference-contact__error');
          if (error) error.textContent = valid ? '' : message;
          return valid;
        };

        fields.forEach((field) => {
          const control = field.querySelector('input:not([type="file"]), select, textarea');
          if (!control) return;
          control.addEventListener('input', () => { if (field.classList.contains('has-error')) check(field); });
          control.addEventListener('change', () => { if (field.classList.contains('has-error')) check(field); });
          control.addEventListener('blur', () => { if (control.value.trim()) check(field); });
        });

        form.addEventListener('submit', (event) => {
          let firstBad = null;
          fields.forEach((field) => {
            if (!check(field) && !firstBad) firstBad = field;
          });

          if (firstBad) {
            event.preventDefault();
            const control = firstBad.querySelector('input:not([type="file"]), select, textarea');
            if (control) control.focus();
            return;
          }

          const button = form.querySelector('[data-submit]');
          const text = form.querySelector('[data-submit-text]');
          if (button) button.setAttribute('aria-disabled', 'true');
          if (text) text.textContent = 'SENDING';
        });

        const fileWrap = this.querySelector('[data-file-field]');
        if (fileWrap) {
          const input = fileWrap.querySelector('input[type="file"]');
          const name = fileWrap.querySelector('[data-file-name]');
          const clear = fileWrap.querySelector('[data-file-clear]');
          const sync = () => {
            const file = input.files && input.files[0];
            name.textContent = file ? file.name : name.dataset.placeholder;
            fileWrap.classList.toggle('has-file', !!file);
            clear.hidden = !file;
          };
          input.addEventListener('change', sync);
          clear.addEventListener('click', () => {
            input.value = '';
            sync();
            input.focus();
          });
        }

        const serverError = this.querySelector('[data-server-error]');
        if (serverError) serverError.focus({ preventScroll: false });
      }

      setupSuccess() {
        const success = this.querySelector('[data-success]');
        if (!success || !/contact_posted/.test(location.search)) return;
        success.focus({ preventScroll: true });
        success.scrollIntoView({ behavior: this.reduced ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
